import GenericDialog from "./generic";
import LabeledField from "providers/labeledField";
import { notifySimple } from "providers/toast";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import GenericButton from "widgets/controls/buttons/generic";
import PinInputs from "widgets/shared/inputs/pinInput";

const MfaDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onOk: (val: string) => void;
  code: string;
  secret: string;
}) => {
  const { isOpen, onClose, onOk, code, secret } = props;
  const { t } = useTranslation();
  const [qrCode, setQrCode] = useState("");

  // Copy secret
  const copyToClipboard = () => {
    navigator.clipboard.writeText(secret).then(
      () => {
        notifySimple(t("toast.copied.to.clipboard"), "success");
      },
      (err) => {
        notifySimple(t("toast.failed.to.copy"), "error");
      }
    );
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("profile.mfa.dialog.title")}
      onClose={onClose}
      onOk={() => onOk(code)}
      onExit={onClose}
      size="md"
    >
      <div className="flex flex-col gap-4">
        <div className="text-wrap text-txt-md text-secondary">
          {t("profile.mfa.dialog.step.one")}
        </div>

        <div className="flex flex-col items-center">
          <div className="">
            <QRCode
              size={256}
              style={{
                maxWidth: "100%",
                height: "auto",
                width: "auto",
              }}
              value={qrCode}
              viewBox={`0 0 256 256`}
            />
          </div>
          <div className="w-3/4 break-words p-3 text-center text-txt-sm text-secondary">
              {secret}
          </div>
          <GenericButton
            text={t("button.action.copy.secret.key")}
            size="md"
            onClick={copyToClipboard}
          />
        </div>

        <LabeledField
          label={t("profile.mfa.dialog.step.two")}
          id={"pin"}
          textColor="secondary"
        >
          <PinInputs
            value={undefined}
            color="secondary"
            onChange={(val: SetStateAction<string>) => {
              setQrCode(val);
            }}
          />
        </LabeledField>
      </div>
    </GenericDialog>
  );
};

export default MfaDialog;
